import { curryN, identity, is } from 'ramda';

export const isStr = x => typeof x === 'string';
export const isNum = x => is(Number, x) && !isNaN(x);
export const isBool = x => typeof x === 'boolean';

/**
 * Creates comparator that sort items as desired and moves all invalid values to the end of collection.
 * To create simple predicate w/o checking invalid use ramda's `ascend`/`descend` functions
 * @function
 * @param {Function} typeValidator
 * @param {boolean|number} asc - order
 * @param {Function} fn - value getter
 * @returns {number}
 */
export const predicate = (
    typeValidator = isStr,
    asc = true,
    fn = identity
) => (a, b) => {
    if (a === b) {
        return 0;
    }

    const aa = fn(a);
    const bb = fn(b);

    const isValidA = typeValidator(aa);
    const isValidB = typeValidator(bb);

    if (!isValidA && !isValidB) {
        return 0;
    }

    if (!isValidB) {
        return -1;
    }
    if (!isValidA) {
        return 1;
    }

    return asc ? aa - bb : bb - aa;
};

/**
 * @type {Function}
 */
export const numberPredicate = curryN(3, predicate)(isNum);
/**
 * @type {Function}
 */
export const stringPredicate = curryN(3, predicate)(isStr);
/**
 * @type {Function}
 */
export const boolPredicate = curryN(3, predicate)(isBool);
